module.exports = __webpack_public_path__ + "img/logo.c3a12b30.svg";